export enum CriteriaThresholdEnum {
  GREEN = 3.5,
  YELLOW = 2,
}
